import React from "react";
import { Button, ButtonProps } from "@mui/material";
import { styled } from "@mui/system";
import { getThemePath } from "../../hooks/useGetThemePath";
import { theme } from "../../theme";

const themePath = getThemePath();
const colors = theme[themePath].colors;

const StyledButton = styled(Button)<any>(() => ({
  borderRadius: "0.3rem 0 0 0.3rem",
  fontFamily: "Inter",
  padding: "0.5rem 0.75rem",
  fontSize: "0.75rem",
  fontWeight: 500,
  color: colors.table.pagination.primary,
  backgroundColor: "transparent",
  border: `1px solid ${colors.table.pagination.border.secondary}`,
  borderRight: 0,
  textTransform: "capitalize",
  width: "40px",
  "&:hover": {
    backgroundColor: colors.table.pagination.bgHover,
  },
  "&:disabled": {
    color: colors.table.pagination.disabled,
    backgroundColor: colors.table.pagination.bgDisabled,
    cursor: "not-allowed",
  },
  "&:active": {
    backgroundColor: colors.table.pagination.bgActive,
    color: colors.table.pagination.primary,
    borderColor: colors.table.pagination.border.secondary,
  },
}));

const BackButton: React.FC<ButtonProps> = ({
  children,
  disabled,
  onClick,
  ...props
}) => {
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      data-cy="previousPageButton"
      aria-label="Go To, Previous Page"
      {...props}
    >
      {children}
    </StyledButton>
  );
};

export default BackButton;
